import { HttpErrorResponse } from '@angular/common/http';

import { AuthErrorCode, AuthUiError } from '../models';

const AUTH_ERROR_MESSAGES: Record<AuthErrorCode, string> = {
  INVALID_CREDENTIALS: 'Mã số sinh viên/email hoặc mật khẩu không đúng.',
  ACCOUNT_LOCKED: 'Tài khoản của bạn đang bị khóa. Vui lòng liên hệ nhà trường để được hỗ trợ.',
  ACCOUNT_PENDING: 'Tài khoản chưa được kích hoạt. Vui lòng liên hệ nhà trường để được hỗ trợ.',
  NETWORK_ERROR: 'Không thể kết nối tới hệ thống. Vui lòng kiểm tra mạng và thử lại.',
  SERVER_ERROR: 'Hệ thống đang tạm thời gián đoạn. Vui lòng thử lại sau.',
  UNKNOWN_ERROR: 'Không thể đăng nhập vào lúc này. Vui lòng thử lại sau.',
};

const KNOWN_AUTH_ERROR_CODES = new Set<AuthErrorCode>([
  'INVALID_CREDENTIALS',
  'ACCOUNT_LOCKED',
  'ACCOUNT_PENDING',
  'NETWORK_ERROR',
  'SERVER_ERROR',
  'UNKNOWN_ERROR',
]);

export function mapAuthError(error: unknown): AuthUiError {
  const code = resolveAuthErrorCode(error);

  return {
    code,
    message: AUTH_ERROR_MESSAGES[code],
  };
}

function resolveAuthErrorCode(error: unknown): AuthErrorCode {
  if (error instanceof HttpErrorResponse) {
    if (error.status === 0) {
      return 'NETWORK_ERROR';
    }

    const responseCode = readResponseCode(error.error);

    if (responseCode && KNOWN_AUTH_ERROR_CODES.has(responseCode)) {
      return responseCode;
    }

    if (error.status >= 500) {
      return 'SERVER_ERROR';
    }
  }

  const responseCode = readResponseCode(error);

  if (responseCode && KNOWN_AUTH_ERROR_CODES.has(responseCode)) {
    return responseCode;
  }

  return 'UNKNOWN_ERROR';
}

function readResponseCode(error: unknown): AuthErrorCode | null {
  if (!error || typeof error !== 'object' || !('code' in error)) {
    return null;
  }

  const code = (error as { readonly code?: unknown }).code;

  return typeof code === 'string' ? (code as AuthErrorCode) : null;
}
